import produce from "immer"
import { BundleDtoAttributes } from "../models/Bundle"
import { BundleItem } from "../models/BundleItem"

export const BundleStateHandler = (state: BundleDtoAttributes) => {
    return {
        bundleAddItem(payload: BundleItem): BundleDtoAttributes {
            return { ...state, bundleProducts: [...state.bundleProducts, payload]}
        },

        bundleRemoveItem(payload: BundleItem): BundleDtoAttributes {
            const index = state.bundleProducts.findIndex(item => item.itemKey === payload.itemKey)
            if (index === -1) return state
            return produce(state, draft => {
                draft.bundleProducts.splice(index, 1)
            })
        },

        bundleUpdateItem(payload: BundleItem[]): BundleDtoAttributes {
            return produce(state, draft => {
                draft.bundleProducts = payload
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/state/product/bundle/reducers/handler.ts